import { types } from "web3";

export const Props = () => ({
  //Главная подпись
  text: {
    type: String,
    required: false,
  },

  //Дополнительный текст
  subtext: {
    type: String,
    required: false,
  },

  //Имя поля для формы
  name: {
    type: String,
    required: false,
  },

  //Имя поля для старых(которые были при инициализации) изображений
  oldImagesFieldName: {
    type: [Array],
    required: false,
  },

  //Файл инициализации
  initData: {
    type: [Object, String],
    required: false,
  },

  //Массив с ссылками на изображения, которые сразу будут отображены в поле
  startImages: {
    type: Array,
    required: false,
  },
  
  //Текст ошибки
  error: {
    type: String,
    required: false,
  }
})
